const language = {
	spanish: {
		header_title: "Fuerza laboral ",
		header_span_title: "de primera línea",
		fuerzaLaboral_red_title: "FUERZA LABORAL DE PRIMERA LÍNEA",
		fuerzaLaboral_bold_title:
			"Desde Foresight GPS tenemos una serie de características que ayudan en la logística y seguridad de todo el personal de primera línea como:",
		fuerzaLaboral_bold_text:
			"Cuerpos de seguridad gubernamental y/o personal médico de todos los niveles.",
		fuerzaLaboral_text: [
			"Los equipos de primera línea necesitan herramientas de alta precisión y confiabilidad para completar sus tareas de forma eficiente, es por ello que desde Foresight GPS hemos desarrollado piezas de software que facilitan las tareas rutinarias y críticas de este tipo de personal.",
		],
		beneficios_red_title: "BENEFICIOS",
		beneficios_bold_title:
			"Contamos con múltiples soluciones para este sector:",
		beneficios_list: [
			{
				text: "Incremente la productividad de su equipo a través de datos precisos",
				column: "1",
			},
			{
				text: "Reducción de trabajo que requiere papel y trabajo.",
				column: "1",
			},
			{
				text: "Personalización completa de funcionalidades según flujo de trabajo",
				column: "1",
			},
			{
				text: "Interfaz fácil de usar e intuitiva.",
				column: "1",
			},
			{
				text: "Permitir una mejor y más rápida toma de decisiones.",
				column: "1",
			},
			{
				text: "Localización en tiempo real",
				column: "1",
			},
			{
				text: "Alertas de ingreso y salida de áreas determinadas sobre mapas digitales",
				column: "2",
			},
			{
				text: "Localización de dispositivos móviles robados o extraviados.",
				column: "2",
			},
			{
				text: "Optimización de recursos según demanda por zona geográfica.",
				column: "2",
			},
			{
				text: "Reducir el tiempo de respuesta ante situaciones críticas.",
				column: "2",
			},
			{
				text: "Monitoreo de rutas o trayectorias específicas por paradas.",
				column: "2",
			},
			{
				text: "Soporte de servicio 24/7.",
				column: "2",
			},
		],
		caracteristicas_red_title: "CARACTERÍSTICAS",
		caracteristicas_bold_text:
			"Contamos con la mejor innovación tecnológica para un rastreo óptimo de sus activos móviles:",
		caracteristicas_list: [
			"Sistema de localización vía GPS y dispositivos móviles",
			"Generador de geocercas, puntos de interés y rutas",
			"Visibilidad de personal sobre mapas digitalizados y fotos satelitales (Google Maps y OSM)",
			"Diversidad de reportes de gestión de personal y flotas",
			"Programar envío recurrente de reportes",
			"Alertas en tiempo real de incidencias de seguridad y logística",
			"Botón de pánico (SOS) a través de aplicación móvil",
			"Gestión de horas de trabajo de cada miembro deL equipo ",
			"Administración de usuarios por roles",
		],
		dashboard_red_title: "DASHBOARD CENTER",
		dashboard_bold_title:
			"Fue diseñado para visualizar los indicadores clave de rendimiento de forma rápida y eficiente, facilitando la toma de decisiones ante grandes volúmenes de datos",
		dashboard_bold_text:
			"Con distintos conjuntos de tableros puedes ver la distancia recorrida por cada miembro del equipo, entradas y salidas de áreas geográficas determinadas, horas de trabajo activo y el tiempo en rutas, y más.",
		dashboard_text: [
			"Además se pueden incluir nuevos sets de datos y personalizar los Dashboard a las necesidad específicas de cada operación.",
		],
		dashboard_list: [
			"Procesamiento de data",
			"Presentación gráfica de resultados",
			"Comparativo de resultados entre diferentes activos",
			"Identificador de variables fuera de rango",
			"Interfaz gráfica amigable y fácil de leer",
			"Control de múltiples variables de manera simultánea",
			"Diseño de tablero a la medida",
		],
		route_red_title: "ROUTE CENTER",
		route_bold_title:
			"Ideal para personal que tenga que seguir una ruta específica. La planificación diaria no tiene porqué ser un dolor de cabeza con nuestro módulo de Route Center.",
		route_bold_text:
			"A su vez, incrementa la puntualidad en las entregas y/o visitas y disfruta de una gestión eficiente.",
		route_text: [
			"Mediante la planificación, el diseño y la asignación de ruta, gerencia el trabajo de un equipo de una manera eficiente. Realiza un seguimiento de las rutas y la actividad diaria del personal y sus rutas en tiempo real.",
		],
		route_list: [
			"Mapeo de áreas de interés sobre mapas digitales",
			"Creación de rutas",
			"Planificación de visitas",
			"Verificación de patrones de visitas",
			"Variedad de reportes ejecutados",
			"Visualización de avances de gestión de pantalla",
		],
	},
	english: {
		header_title: "Essential ",
		header_span_title: "Workforce",
		fuerzaLaboral_red_title: "ESSENTIAL WORKFORCE",
		fuerzaLaboral_bold_title:
			"In ForesightGPS we have some features to help in the logistics and security of all frontline personnel such as:",
		fuerzaLaboral_bold_text:
			"Security forces and medical personnel of all levels.",
		fuerzaLaboral_text: [
			"Frontline workers need high precision and reliable tools to complete their tasks efficiently, which is why we have developed pieces of software that alleviates routine and critical tasks for the workforce.",
		],
		beneficios_red_title: "BENEFITS",
		beneficios_bold_title: "We have multiple solutions for this sector:",
		beneficios_list: [
			{
				text: "Increase your team’s productivity through accurate data.",
				column: "1",
			},
			{
				text: "Reduction of paper requiring labor and manual labor.",
				column: "1",
			},
			{
				text: "Customization of functionalities according to workflow.",
				column: "1",
			},
			{
				text: "Easy to use and intuitive interface.",
				column: "1",
			},
			{
				text: "Allow better and faster decision making.",
				column: "1",
			},
			{
				text: "Real time location.",
				column: "1",
			},
			{
				text: "Entry and exit alerts of certain areas on digital maps.",
				column: "2",
			},
			{
				text: "Location of lost or stolen devices.",
				column: "2",
			},
			{
				text: "Optimization of resources according to demand by geographical areas.",
				column: "2",
			},
			{
				text: "Reduce response time in critical situations.",
				column: "2",
			},
			{
				text: "Monitoring of specific routes by stops.",
				column: "2",
			},
			{
				text: "24/7 support.",
				column: "2",
			},
		],
		caracteristicas_red_title: "FEATURES",
		caracteristicas_bold_text:
			"We have the best technological innovations for the optimal tracking of your mobile assets:",
		caracteristicas_list: [
			"Location system via GPS and mobile devices",
			"Addition of geofences, points of interests and routes",
			"Staff visibility on digital maps and satellite photos (Google Maps and OSM)",
			"Variety of reports on personnel and fleet management ",
			"Schedule report sending",
			"Real time alerts of security and logistics incidents",
			"Panic button (SOS) via mobile app",
			"Management of working hours for each team member",
			"User management by roles",
		],
		dashboard_red_title: "DASHBOARD CENTER",
		dashboard_bold_title:
			"Designed to display key performance indicators quickly and efficiently, facilitating      decision making when faced with large volumes of data.",
		dashboard_bold_text:
			"With different sets of dashboards allow you to view distance traveled by each member, entries and exits from specific areas, active work hours on routes, and more.",
		dashboard_text: [
			"Also can be customized to the specific needs of operation, including new data sets.",
		],
		dashboard_list: [
			"Data processing",
			"Graphic presentation of results",
			"Comparison of results between different assets",
			"Out of range variable identifier",
			"Friendly and easy to read graphical interface",
			"Simultaneous control of multiple variables",
			"Custom board design",
		],
		route_red_title: "ROUTE CENTER",
		route_bold_title:
			"Ideal for personnel who follow a specific route. Daily planning does not have to be a headache with our route center module.",
		route_bold_text: "In turn increases punctuality in deliveries or visits and efficient management.",
		route_text: [
			"Thought planning, design, and routing, manage your fleets work efficiently. Track the routes and daily activities of the fleet in real time or through reports, validating the fulfillment of tasks.",
		],
		route_list: [
			"Mapping areas of interest",
			"Route creation",
			"Visit planning.",
			"Verification of visit patterns",
			"Variety of executed reports",
			"Viewing screen of management process",
		],
	},
};

export default language